<div fxLayout="column" fxLayoutAlign=" center">
    <H1 *ngIf="name">{{name}}, Submit Successful</H1>
    <H1 *ngIf="!name">Submit Successful</H1>
    <p>Thank you for submitting!</p>
    <div class="submit-another-wrapper">
        <button mat-raised-button color="primary" (click)="onSubmitAnotherClick()">Submit Another</button>
    </div>
</div>
